import initGrabScroll from './initGrabScroll';

const setupInsuranceScenario = (root) => {
	const carousel = root.querySelector('[data-insurance-carousel]');
	if (!carousel) return;

	initGrabScroll(root);

	const prev = root.querySelector('[data-insurance-prev]');
	const next = root.querySelector('[data-insurance-next]');
	if (!prev || !next) return;

	const getCardScrollAmount = () => {
		const card = carousel.querySelector('.insurance-scenario-card');
		if (!card) return 324;
		const gap = parseInt(window.getComputedStyle(carousel).columnGap, 10) || 24;
		return card.offsetWidth + gap;
	};

	const updateArrows = () => {
		const isAtStart = carousel.scrollLeft <= 1;
		const isAtEnd =
			carousel.scrollLeft + carousel.clientWidth + 1 >= carousel.scrollWidth;
		prev.classList.toggle('opacity-30', isAtStart);
		next.classList.toggle('opacity-30', isAtEnd);
	};

	prev.addEventListener('click', () => {
		carousel.scrollBy({
			left: -getCardScrollAmount(),
			behavior: 'smooth',
		});
	});

	next.addEventListener('click', () => {
		carousel.scrollBy({
			left: getCardScrollAmount(),
			behavior: 'smooth',
		});
	});

	carousel.addEventListener('scroll', updateArrows);
	window.addEventListener('resize', updateArrows);
	updateArrows();
};

document
	.querySelectorAll('.insurance-scenario')
	.forEach(setupInsuranceScenario);
